import script from "./ProcedureTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureTable.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureTable.vue?vue&type=style&index=0&id=5629e556&lang=scss"

const __exports__ = script;

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter});
